import React from "react";
import { Wrapper } from "./paymentViaCard.styles";
import { NavLink } from "react-router-dom";
import { PRIVATE_ROUTE } from "../../route.constants";

export default function PaymentViaCard(props) {

  let ButtonRender = () => (
    <NavLink className="button" to={PRIVATE_ROUTE.EZIDEBIT}>
        <span>Make a payment now</span>
      </NavLink>
  );

  

  return (
    <Wrapper>
      <div
        style={{ height: "100%", position: "unset" }}
        className="flex-column space-between"
      >
        <div>
          <h4>{props.heading}</h4>
          <p>{props.subText}</p>
          {props.listElements && (
            <ul>
              {props.listElements.map((listItem, index) => (
                <li key={index}>{listItem}</li>
              ))}
            </ul>
          )}
        </div>
        {props.showButton && <ButtonRender />}
      </div>
    </Wrapper>
  );
}
